import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const notFoundSliceName = 'not-found';

export const notFoundSlice = createSlice({
  name: notFoundSliceName,
  initialState: {
    isNotFound: false,
  },
  reducers: {
    setIsNotFound(state, { payload: isNotFound }: PayloadAction<boolean>) {
      state.isNotFound = isNotFound;
    },
  },
});

export type NotFound = ReturnType<typeof notFoundSlice.getInitialState>;
export default notFoundSlice.reducer;
export const { setIsNotFound } = notFoundSlice.actions;
